<button
    #filterbutton
    (click)="toggleOAFilter(filterbutton)"
    type="button"
    class="btn filter-button"
>
    <ng-content></ng-content>
</button>
<div
    class="filters-applied p-1"
    *ngIf="hasFiltersApplied == true"
>
    {{ i18n._7300_FILTERED_BY | translate }}:
    <span
        class="filter"
        *ngFor="
            let filter of appliedFilters;
            let last = last;
            let index = index;
            trackBy: trackFilterLabel
        "
    >
        {{ filter.label }}<span *ngIf="!last">,</span>
    </span>
</div>

<ng-template #filterwindowtpl>
    <div class="cmps-widget-coaching-insight">
        <div class="temp-cmps-team-oa-metrics">
            <div
                class="oa-filter-window"
                #oaFilterWindow
            >
                <div class="arrow_box">
                    <div
                        class="cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-p-0dot25"
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400 cmps-cdk-cursor-pointer"
                            svgIcon="close"
                            (click)="closeOAFilter()"
                        ></cmps-icon>
                    </div>
                    <div class="oa-add-filter-sec">
                        <h1>{{ i18n._7360_FILTER | translate }}</h1>
                        <div class="oa-filters-container">
                            <div class="row p-2">
                                <div class="col-md-2 oa-filters-title">
                                    <span>{{
                                        i18n._713_METRIC | translate
                                    }}</span>
                                </div>
                                <div class="col-md-10">
                                    <div class="row nogutter">
                                        <div
                                            class="col-md-10 oa-metric-filter-dropdown"
                                        >
                                            <ng-select
                                                [options]="
                                                    oametricsoptions | async
                                                "
                                                [notFoundMsg]="
                                                    i18n._7413_NO_RESULTS_FOUND
                                                        | translate
                                                "
                                                [ngModel]="
                                                    oafilterMetricsSelected
                                                "
                                                (ngModelChange)="
                                                    onOaFilterMetricSelected(
                                                        $event
                                                    )
                                                "
                                                forceDropdownPosition
                                            ></ng-select>
                                        </div>
                                        <div
                                            class="col-md-1 oa-filter-add-metric-button cmps-cdk-cursor-pointer"
                                            [class.active]="
                                                tempMetricValue != null
                                            "
                                            (click)="addMetricToFilters()"
                                        >
                                            <cmps-icon
                                                svgIcon="plus-circle"
                                            ></cmps-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col-2 oa-filters-title">
                                    <span></span>
                                </div>
                                <div class="col-10 oa-metric-filter-container">
                                    <div
                                        *ngFor="
                                            let mfilter of filterOptions.filterMetrics;
                                            let index = index;
                                            trackBy: trackFilterOptions(
                                                index,
                                                mfilter
                                            )
                                        "
                                        class="oa-metric-filter-item cmps-cdk-cursor-pointer"
                                        (click)="
                                            removeMetricFromFilters(mfilter)
                                        "
                                    >
                                        <span>{{ mfilter.label }}</span>
                                        <cmps-icon svgIcon="close"></cmps-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="row p-2">
                                <div class="col-md-2 oa-filters-title">
                                    <span>{{
                                        i18n._7301_SORT_BY | translate
                                    }}</span>
                                </div>
                                <div class="col-md-10">
                                    <div class="row nogutter">
                                        <div
                                            class="col-md-9 oa-metric-filter-dropdown"
                                        >
                                            <ng-select
                                                [options]="oafilterSortOptions"
                                                [notFoundMsg]="
                                                    i18n._7413_NO_RESULTS_FOUND
                                                        | translate
                                                "
                                                [(ngModel)]="
                                                    filterOptions.filterSort
                                                "
                                                forceDropdownPosition
                                            ></ng-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="oa-filter-window-footer text-right">
                            <div
                                class="float-right"
                                role="group"
                            >
                                <span
                                    *ngIf="noFilterOptionsSelected"
                                    class="filter-error"
                                    >{{
                                        i18n._7302_PLEASE_ADD_FILTER_OPTIONS
                                            | translate
                                    }}.</span
                                >
                                <button
                                    class="btn green-button"
                                    (click)="applyFilters()"
                                >
                                    {{ i18n._7303_APPLY_FILTERS | translate }}
                                </button>
                                <button
                                    class="btn gray-button"
                                    (click)="clearFilters()"
                                >
                                    {{ i18n._7304_CLEAR_FILTERS | translate }}
                                </button>
                            </div>
                            <i
                                attr-hidden="true"
                                class="clearfix"
                            ></i>
                        </div>
                    </div>

                    <div class="oa-add-remove-sec">
                        <div class="oa-add-remove-secs oa-add-remove-sec-1">
                            <h1>{{ i18n._7511_COLUMNS | translate }}</h1>
                            <div class="row">
                                <ng-container *ngFor="let col of ColumnsConfig">
                                    <div class="col-6">
                                        <div
                                            class="custom-control custom-control-inline custom-checkbox"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                [id]="'togglecol' + col.header"
                                                [checked]="col.active"
                                                (change)="
                                                    toggleColumnByIndex(
                                                        col.index
                                                    )
                                                "
                                                (click)="
                                                    $event.stopPropagation()
                                                "
                                            />
                                            <label
                                                class="custom-control-label"
                                                (click)="
                                                    $event.stopPropagation()
                                                "
                                                [for]="'togglecol' + col.header"
                                            >
                                                {{ col.header | translate }}
                                            </label>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <hr />

                        <div class="oa-add-remove-secs oa-add-remove-sec-2">
                            <h1>{{ i18n._7512_PEOPLE | translate }}</h1>
                            <div class="row">
                                <div class="col-12 text-left">
                                    <div
                                        class="custom-control custom-control-inline custom-checkbox"
                                    >
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="toggleactiveperformers"
                                            [checked]="showActivePerformers"
                                            (change)="
                                                toggleShowActivePerformers(
                                                    $event
                                                )
                                            "
                                            (click)="$event.stopPropagation()"
                                        />
                                        <label
                                            class="custom-control-label"
                                            (click)="$event.stopPropagation()"
                                            for="toggleactiveperformers"
                                        >
                                            {{
                                                i18n._7510_SHOW_PREVIOUS_DIRECT_REPORTS
                                                    | translate
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="check-list">

                                <div class="custom-control custom-control-inline custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                        id="toggleactiveperformers"
                                        [checked]="showActivePerformers"
                                        (change)="toggleShowActivePerformers($event)"
                                        (click)="$event.stopPropagation()" />
                                    <label class="custom-control-label" (click)="$event.stopPropagation()" for="toggleactiveperformers">
                                        Toggle Active Performers
                                    </label>
                                </div>

                                <div class="custom-control custom-control-inline custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                        id="toggleactiveperformers"
                                        [checked]="showActivePerformers"
                                        (change)="toggleShowActivePerformers($event)"
                                        (click)="$event.stopPropagation()" />
                                    <label class="custom-control-label" (click)="$event.stopPropagation()" for="toggleactiveperformers">
                                        Toggle Active Performers
                                    </label>
                                </div>

                            </div> -->
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
